import * as React from "react";
import { useFormContext } from "react-hook-form";
import { AutoComplete, Modal } from "components";
import { DENTAL_PROCEDURES, TPLO_PROCEDURE, useCurrentCase } from "duck";
import { SpeciesEnum } from "requests";
import { Types } from "../../duck";
import { hasTPLOData, hasDentalChartingData } from "./duck";

const Procedures: React.FC = () => {
  const { watch, setValue } = useFormContext<Types.FormValues>();

  const species = watch("species");

  const {
    hadTPLOData,
    hadDentalData,
    hadDentalProcedure,
    hadTPLOProcedure,
    isCopied
  } = useCurrentCase(state => {
    const { createdFrom } = state.data;
    const {
      procedures,
      generalAssessment,
      tibialPlateauLevelingOsteotomyPlanning
    } = state.data.client.patient;
    return {
      hadDentalData: hasDentalChartingData(generalAssessment),
      hadDentalProcedure: procedures?.some(procedure =>
        DENTAL_PROCEDURES.includes(procedure)
      ),

      hadTPLOData: hasTPLOData(tibialPlateauLevelingOsteotomyPlanning),
      hadTPLOProcedure: procedures?.includes(TPLO_PROCEDURE),

      isCopied: !!createdFrom
    };
  });

  return (
    <AutoComplete.Procedures
      creatable
      optionValue="name"
      name="procedures"
      label="Procedures to be performed"
      placeholder="Select Procedures to be performed"
      isOptionDisabled={
        species === SpeciesEnum.Cat ||
        species === SpeciesEnum.Dog ||
        species === SpeciesEnum.Rabbit
          ? undefined
          : opt => DENTAL_PROCEDURES.includes(opt.name)
      }
      onChange={newValue => {
        const hasDentalProcedure = newValue.some(value =>
          DENTAL_PROCEDURES.includes(value)
        );
        const hasTPLOProcedure = newValue.includes(TPLO_PROCEDURE);

        const dentalRemoved = hadDentalProcedure && !hasDentalProcedure;
        const tploRemoved = hadTPLOProcedure && !hasTPLOProcedure;

        if (dentalRemoved && hadDentalData && !isCopied) {
          Modal.instance.open({
            title: "Remove Dental Charting Data",
            description:
              "Are you sure you want to remove this procedure? Data on Dental Charting will be deleted and you will not be able to undo this action.",
            onOk() {
              setValue("procedures", newValue);
            }
          });
        } else if (tploRemoved && hadTPLOData) {
          Modal.instance.open({
            title: "Remove TPLO Data",
            description:
              "Are you sure you want to remove this procedure? Data on TPLO will be deleted and you will not be able to undo this action.",
            onOk() {
              setValue("procedures", newValue);
            }
          });
        } else {
          setValue("procedures", newValue);
        }
      }}
    />
  );
};

export default Procedures;
